goog.provide("shadow.js.shim.module$src$svg$wpp$charts$ranking_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$charts$ranking_svg");
shadow.js.shim.module$src$svg$wpp$charts$ranking_svg = shadow.js.nativeProvides["src/svg/wpp/charts/ranking.svg"] = shadow$bridge("src/svg/wpp/charts/ranking.svg");
module$shadow_js_shim_module$src$svg$wpp$charts$ranking_svg.default = shadow.js.shim.module$src$svg$wpp$charts$ranking_svg;
